import angular from 'angular'
import adminCtrl from './adminCtrl'
// import homeCtrl from './homeCtrl'

import adminPage from './views/admin.html'
import homePage from './views/home.html'

// 步骤模块
function config($stateProvider) {
    $stateProvider
        .state('home', {
            url: '/home',
            abstract: true,
            template: homePage,
            // controller: 'homeCtrl',
        })
        .state('home.admin', {
            url: '/admin',
            template: adminPage,
            controller: 'adminCtrl',
            title: '主页',
        })
}

export default angular
    .module('app.home', [])
    .config(['$stateProvider', config])
    // .controller('homeCtrl', homeCtrl)
    .controller('adminCtrl', adminCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/main/home/index.js